import React from 'react';
import { useSelector } from 'react-redux';
import { TablePagination } from '../shared/table/TablePagination';
import { AuditLogDetailModal, AuditLogFiltersDrawer, AuditLogTable } from './components';
import { AUDIT_ACTION_OPTIONS, AUDIT_ENTITY_TYPE_OPTIONS } from './helpers';
import { useAuditLogListScreen } from './hooks';

export const AuditLogListScreen = () => {
    const { token, role } = useSelector((state) => state.auth);
    const {
        searchTerm,
        setSearchTerm,
        entityType,
        setEntityType,
        action,
        setAction,
        actorUserId,
        setActorUserId,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
        limit,
        setLimit,
        offset,
        setOffset,
        isFiltersOpen,
        openFilters,
        closeFilters,
        clearFilters,
        hasActiveFilters,
        auditLogs,
        actorOptions,
        isLoading,
        error,
        total,
        hasNext,
        hasPrev,
        selectedLog,
        isDetailOpen,
        detailLoading,
        detailError,
        openDetail,
        closeDetail,
    } = useAuditLogListScreen({ token, role });

    if (role !== 'ADMIN') {
        return (
            <div className="row px-2 px-md-3 py-3">
                <div className="col-12 col-xl-8 mx-auto">
                    <div className="card card__no-border">
                        <div className="card-body p-4 text-center">
                            <h4 className="fw-bold mb-2">Acceso restringido</h4>
                            <p className="text-muted mb-0">Solo los administradores pueden consultar el historial de auditoría del tenant.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="row px-2 px-md-3 py-3">
            <div className="col-12 col-xxl-11 mx-auto">
                <div className="card card__no-border audit-log-screen">
                    <div className="card-body p-3 p-md-4">
                        <div className="audit-log-screen__hero">
                            <div>
                                <h4 className="fw-bold mb-1">Tenant Audit Log</h4>
                                <p className="text-muted mb-0">Consulta cambios críticos sobre tickets, usuarios, clientes, proyectos, grupos y seguimientos.</p>
                            </div>
                            <div className="audit-log-screen__summary">
                                <span>{total} registro{total === 1 ? '' : 's'}</span>
                                <button type="button" className="btn btn-light-brand" onClick={openFilters}>
                                    <i className="feather-sliders me-2" />
                                    Filtros
                                </button>
                            </div>
                        </div>

                        <div className="audit-log-toolbar">
                            <div className="search-modal__search-shell search-modal__search-shell--page audit-log-toolbar__search">
                                <i className="feather-search search-modal__search-icon" aria-hidden="true" />
                                <input
                                    type="search"
                                    className="search-modal__input"
                                    value={searchTerm}
                                    onChange={(event) => setSearchTerm(event.target.value)}
                                    placeholder="Buscar por actor, resumen, entidad o código..."
                                />
                            </div>
                            {hasActiveFilters && (
                                <button type="button" className="btn btn-outline-secondary" onClick={clearFilters}>
                                    Limpiar filtros
                                </button>
                            )}
                        </div>

                        {error && <div className="alert alert-danger py-2">{error}</div>}

                        <AuditLogTable auditLogs={auditLogs} isLoading={isLoading} onOpenDetail={openDetail} />

                        <TablePagination
                            total={total}
                            limit={limit}
                            offset={offset}
                            hasNext={hasNext}
                            hasPrev={hasPrev}
                            onOffsetChange={setOffset}
                            isLoading={isLoading}
                        />
                    </div>
                </div>
            </div>

            <AuditLogFiltersDrawer
                isOpen={isFiltersOpen}
                onClose={closeFilters}
                searchTerm={searchTerm}
                onSearchTermChange={setSearchTerm}
                entityType={entityType}
                entityTypeOptions={AUDIT_ENTITY_TYPE_OPTIONS}
                onEntityTypeChange={setEntityType}
                action={action}
                actionOptions={AUDIT_ACTION_OPTIONS}
                onActionChange={setAction}
                actorUserId={actorUserId}
                actorOptions={actorOptions}
                onActorUserIdChange={setActorUserId}
                dateFrom={dateFrom}
                onDateFromChange={setDateFrom}
                dateTo={dateTo}
                onDateToChange={setDateTo}
                rowsPerPage={limit}
                onRowsPerPageChange={setLimit}
                onClearFilters={clearFilters}
            />

            <AuditLogDetailModal
                isOpen={isDetailOpen}
                auditLog={selectedLog}
                isLoading={detailLoading}
                error={detailError}
                onClose={closeDetail}
            />
        </div>
    );
};